import { useState, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { CHAR_LENGTH } from 'components/Reporting/Overview/FilterBuilder/FilterSet/Constants'

type SaveContent = {
  text: string
  validation: string | undefined
  position: string
  isError: boolean
}

export const useValidation = ({ savedFilter }: { savedFilter?: string }) => {
  const { t } = useTranslation()
  const [textValue, setTextValue] = useState<SaveContent>({
    text: '',
    validation: undefined,
    position: 'right',
    isError: false,
  })

  const handleChange = useCallback((e: any) => {
    const text = e?.target?.value?.replace(/\n/g, '') || ''

    let updatedValue: any = {
      validation: undefined,
      position: 'right',
      isError: false,
    }
    const invalidCharPattern = /[^\w @_.'&-]/gi
    const hasInvalidChars = invalidCharPattern.test(text)

    switch (true) {
      case hasInvalidChars:
        updatedValue = {
          position: 'left',
          validation: t('reporting.filterSet.validChars'),
          isError: true,
        }
        break
      case text.length === CHAR_LENGTH:
        updatedValue = {
          position: 'right',
          validation: t('reporting.filterSet.charLimit'),
          isError: true,
        }
        break

      case text.trim().length === 0:
        updatedValue = {
          isError: true,
          validation: t('reporting.filterSet.requiredFiled'),
          position: 'left',
        }
        break

      default:
        updatedValue = {
          position: 'right',
          isError: false,
        }
        break
    }

    setTextValue((prevState: any) => ({
      text: e?.target?.value?.replace(/\n/g, ''),
      ...updatedValue,
      ...prevState?.textValue,
    }))
  }, [])

  const updateValue = useCallback((data: any) => {
    setTextValue(data)
  }, [])

  useEffect(() => {
    updateValue(savedFilter)
  }, [savedFilter])

  return { handleChange, setTextValue, updateValue, textValue }
}

export default useValidation
